import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconLazo = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5C8.68629 5 6 7.68629 6 11C6 11.7597 6.14119 12.4864 6.39875 13.1553C4.75005 13.6323 3.54454 15.1531 3.54454 16.9555V17.4555C3.54454 18.3085 2.85302 19 2 19C1.44772 19 1 19.4477 1 20C1 20.5523 1.44772 21 2 21C3.95759 21 5.54454 19.4131 5.54454 17.4555V16.9555C5.54454 15.8755 6.42003 15 7.5 15V14.9687C8.59942 16.2144 10.208 17 12 17H15C18.3137 17 21 14.3137 21 11C21 7.68629 18.3137 5 15 5H12ZM8 11C8 8.79086 9.79086 7 12 7H15C17.2091 7 19 8.79086 19 11C19 13.2091 17.2091 15 15 15H12C9.79086 15 8 13.2091 8 11Z"
        />
      </svg>
    );
  }
);
